import { GetStepMaterializationDatesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface StepsMaterializationDateVariables {
  materializedProcessId: number
}

export const useStepsMaterializationDate = (variables: StepsMaterializationDateVariables) => {
  const { data, loading } = useQuery(GetStepMaterializationDatesDocument, {
    variables,
  })

  const steps = data?.processes.stepMaterializationDates ?? []

  return {
    loading,
    steps,
  }
}
